export const STARFISH_KIT_EN_SKU = 'TL0699'
export const STARFISH_KIT_FR_SKU = 'TL0700A'
export const STARFISH_KIT_ES_SKU = 'TL0701'